<template>
    <div class="mx-auto col-lg-10 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('forthing.contract-history.title-label') }}</h3>
        </div>
        <div v-for="item in list">
            <div class="card mb-4">
                <div class="card-body d-flex flex-column flex-fill">
                    <div class="d-flex flex-row flex-fill">
                        <div class="d-flex flex-column flex-fill ml-3 align-content-stretch">
                            <div class="d-flex flex-row flex-fill flex-wrap">
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('aube-coin.forthing.contract-history.completion-date-label') }}
                                    </div>
                                    <div>
                                        {{ item.payment_date }}
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-fill remark">
                                    <div class="font-weight-bold">
                                        {{ $t('aube-coin.forthing.contract-history.remittance') }}
                                    </div>
                                    <div>
                                        <span>
                                            {{ item.amount | roundup }}
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-fill unit">
                                    <div class="font-weight-bold">
                                        {{ $t('aube-coin.forthing.contract-history.unit') }}
                                    </div>
                                    <div>
                                        <span>
                                            {{ item.unit }}
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('aube-coin.forthing.contract-history.start-date-label') }}
                                    </div>
                                    <div>
                                        {{ item.enables_at }}
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-fill width-auto">
                                    <div class="font-weight-bold">
                                        {{ $t('aube-coin.forthing.contract-history.end-date-label') }}
                                    </div>
                                    <div>
                                        {{ item.expires_at }}
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-fill remark">
                                    <div class="font-weight-bold">
                                        {{ $t('aube-coin.forthing.contract-history.campaign_label') }}
                                    </div>
                                    <span v-if="item.is_campaign">{{ $t('aube-coin.forthing.contract-history.campaign') }}</span>
                                    <span v-if="item.is_campaign">{{ $t('aube-coin.forthing.contract-history.free') }}</span>
                                    <span v-if="item.signed_source === 'SMART_POOL'">{{ $t('aube-coin.forthing.contract-history.smart_pool') }}</span>
                                    <span v-if="item.signed_source === 'SMART_POOL'">{{ $t('aube-coin.forthing.contract-history.free') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from './../../services/UserService';

    export default {
        name: 'historyOfForthingAgreement',

        data() {
            return {
                list: [],
            }
        },

        mounted() {
        },

        created() {
            this.getMembershipHistory();
        },

        methods: {
            async getMembershipHistory() {
                try {
                    const data = (await UserService.getMembershipHistory()).data;
                    if (data) {
                        for (let i in data) {
                            if (data.hasOwnProperty(i) && i !== 'meta') {
                                this.list.push(data[i]);
                            }
                        }
                    } else {
                        this.list = [];
                    }
                }catch{
                    this.list = [];
                }
            }
        }
    }
</script>

<style scoped>
.remark {
    width: 160px !important;
}

.unit {
    width: 130px;
}

.width-auto {
    width: auto;
}

@media screen and (max-width: 500px) {
    .width-auto {
        width: 100%;
    }

    .width-auto + .width-auto,
    .width-auto {
        margin-top: .5em;
    }
}
</style>
